module.exports = __webpack_public_path__ + "img/question15.fba05b8c.png";